import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Navbar from "../Navbar";
import TreatImage from "./TreatImage";
import { payForTreat } from "../../services/treatApi";
import "../Pro/Pro.css";
import "./Treat.css";

// =====================================================
// TREAT CONFIRMATION  (Step 4)  — /buy-treat/:blogId/confirm
//
// The price shown is a label; the server creates the order at the database
// price and verifies the paid amount itself, so nothing on this page can
// change what is charged.
// =====================================================

function TreatConfirm() {
  const { blogId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;

  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  // Opened directly (refresh / shared link) — start again from the choice.
  useEffect(() => {
    if (!state?.treat) navigate(`/buy-treat/${blogId}`, { replace: true });
  }, [state, blogId, navigate]);

  if (!state?.treat) return null;

  const { treat, message, blogger, blog } = state;

  const goBack = () => navigate(`/buy-treat/${blogId}`, { state: { treat, message } });

  const pay = () => {
    setBusy(true);
    setError("");
    payForTreat({
      blogId,
      treatId: treat._id,
      message,
      userName: localStorage.getItem("username") || "",
      onSuccess: (res) => navigate(`/treat-sent/${res.treatId}`, { replace: true }),
      onError: (text) => {
        setBusy(false);
        setError(text);
      },
      onClose: () => setBusy(false),
    });
  };

  return (
    <div className="pro-page-wrap">
      <Navbar />
      <div className="pro-container pro-container-narrow">
        <header className="pro-hero pro-hero-compact">
          <div className="pro-hero-badge">🎁 CONFIRM YOUR TREAT</div>
          <h1 className="pro-hero-title">You are sending this treat to support the blogger.</h1>
        </header>

        <div className="pro-card treat-confirm">
          <TreatImage image={treat.image} name={treat.name} size={88} />
          <dl className="treat-confirm-list">
            <div><dt>Selected Treat</dt><dd>{treat.name}</dd></div>
            <div><dt>Treat Price</dt><dd>Rs. {treat.priceRupees}</dd></div>
            <div><dt>Blogger Name</dt><dd>{blogger?.name || "—"}</dd></div>
            {blog?.title && <div><dt>Blog</dt><dd>{blog.title}</dd></div>}
            {message && <div><dt>Your greeting</dt><dd>“{message}”</dd></div>}
          </dl>

          {error && <p className="pro-error" role="alert">{error}</p>}

          <div className="treat-actions">
            <button type="button" className="pro-btn pro-btn-ghost" onClick={goBack} disabled={busy}>
              Go Back
            </button>
            <button type="button" className="pro-btn pro-btn-primary" onClick={pay} disabled={busy}>
              {busy ? "Processing…" : "Continue to Payment"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TreatConfirm;
